/* eslint-disable camelcase */

export interface IFacetOption {
  count: number;
  data?: {
    description?: string;
    gender?: string;
    hex?: string;
    location?: string;
    mobile?: { imageUrl?: string };
    parent?: string;
    product_type?: string;
    sizing_info?: {
      [key: string]: {
        [key: string]: {
          [key: string]: string;
        };
      };
    };
    web?: { imageUrl?: string };
    year?: string;
  };
  display_name: string;
  range?: (string | number)[];
  status: string;
  value: string;
}

export interface IConstructorFacetMultiple {
  data: Record<string, unknown>;
  display_name: string;
  name: string;
  options: Array<IFacetOption>;
  type: string;
}

export interface IConstructorFacetRange {
  data: Record<string, any>;
  display_name: string;
  max: number;
  min: number;
  name: string;
  status: { min?: number; max?: number };
  type: string;
}

export type IConstructorFacet = IConstructorFacetMultiple | IConstructorFacetRange;

export const isIConstructorFacetMultiple = (
  facet: IConstructorFacet,
): facet is IConstructorFacetMultiple => {
  if (!facet) return false;

  return 'options' in facet;
};

export const isIConstructorFacetRange = (
  facet: IConstructorFacet,
): facet is IConstructorFacetRange => {
  if (!facet) return false;

  return 'status' in facet;
};
